import React, {useEffect, useState} from 'react';
import {getPeriodicElements} from "../../services/CourseRepository";
import {PeriodicElement} from "./PeriodicElement";
import {PeriodicElementDetailed} from "./PeriodicElementDetailed";

export function PeriodicTable() {

    const [elements, setElements] = useState([]);
    const [chemicalSeries, setChemicalSeries] = useState([]);
    const [selectedElement, setSelectedElement] = useState(null);


    useEffect(() => {
        if(elements.length === 0) {
            getPeriodicElements().then(result => {
                setElements(result);
                const uniqueClassifications = [...new Set(result.map(item => JSON.stringify(item.classification)))].map(str => JSON.parse(str));
                setChemicalSeries(uniqueClassifications);
            }).catch(error => console.log(error))

        }
    }, []);

    const colors = [
        "#59CD90",
        "#6F2DBD",
        "#094D6F",
        "#8A938F",
        "#3FA7D6",
        "#BFC4C2",
        "#ee9852",
        "#951E0F",
        "#F49B90",
        "#aee5fd",
        "#C9ACEC"];


    function clickElement(element) {
        if(selectedElement == element) {
            setSelectedElement(null);
        }else {
            setSelectedElement(element);
        }
    }


    if(elements.length > 0) {
        const headers = Array.from({ length: 18 }, (_, index) => index + 1);

        return (
          <div className={"w-100 mb-5 mt-3 d-flex flex-column justify-content-center align-content-center  py-5"}>
              <div className={"grid-container rounded"}>
                  <div className={"grid"} style={{gridGap:"px"}}>
                      {
                          headers.map(i => (
                              <div className={"grid-item m-0 p-0"} style={{ gridColumn: `${i + 2} / span 1`, gridRow: `${1} / span 1` }}>
                                  <p className={" m-0 mb-3 p-0 text-center"}>{i}</p>
                              </div>
                              ))
                      }

                      {
                          elements.map((element, idx) => (

                              <>
                                  {
                                      element.period === 1 ?
                                          <div className={"grid-item m-0 p-0 "} style={{ gridColumn: `${1} / span 1`, gridRow: `${element.group +2} / span 1` }}>
                                              <p className={"m-0  me-3 p-0 text-center"}>{element.y}</p>
                                          </div>
                                          :
                                          null
                              }
                                  <div className={"grid-item m-0 p-0"} style={{ gridColumn: `${element.period + 2} / span 1`, gridRow: `${element.group + 2} / span 1` }}  onClick={()=> clickElement(element)}>

                                      <PeriodicElement element={element} color={colors[element.classification.id-1]}/>
                                  </div>

                                  {
                                      element.period === 18 ?
                                          <div className={"grid-item m-0 p-0 "} style={{ gridColumn: `${element.period + 3} / span 1`, gridRow: `${element.group +2} / span 1` }}>
                                              <p className={"m-0  ms-3 text-end"}>{element.group}</p>
                                          </div>
                                          :
                                          null
                                  }
                            </>
                          ))
                      }



                  </div>
              </div>



              {
                  selectedElement != null ?
                      <PeriodicElementDetailed element={selectedElement} color={colors[selectedElement.classification.id-1]}/>
                      :
                      <div className={"d-flex mt-4 align-content-center justify-content-center text-center"}>
                          {
                              chemicalSeries.map(series => (

                                  <div className={"d-flex flex-column justify-content-center text-center align-items-center"}>
                                      <div className={"m-0 p-0"} style={{backgroundColor:colors[series.id-1], color:colors[series.id-1], width:"2vw", height:"2vw"}}></div>
                                      <div style={{width:"5vw"}}>
                                          <p style={{fontSize:"0.6em"}}>{series.name}</p>
                                      </div>
                                  </div>

                              ))
                          }
                      </div>
              }



          </div>
        );

    }

}